import PropTypes from 'prop-types'

function tuple(typeCheckers) {
  return PropTypes.arrayOf(function (value, index, ...rest) {
    return typeCheckers[index]?.call(PropTypes, value, index, ...rest)
  })
}

export { tuple }
